import { getCurrentInstance } from '@vue/composition-api';

import { BASKET_TAB_VALUE } from '@/enums';

const useWishList = () => {
  const { emit } = getCurrentInstance();

  const getCategoryItem = (product) => {
    let id = '0';
    if (product?.category?.id) {
      id = product.category.id;
    }
    return id;
  };

  const handlerSpliceWishItem = (data) => {
    emit('spliceWishItem', data);
  };

  const handlerRestoreWishItem = (data) => {
    emit('restoreWishItem', data);
  };

  const handlerRemoveWishItem = (data) => {
    emit('removeWishItem', data);
  };

  const handlerClickNotAvailable = (data) => {
    emit('clickNotAvailable', data);
  };

  const handlerLoadMore = () => {
    emit('loadMoreWishList');
  };

  const handlerAddToBasketItem = (data) => {
    emit('addToBasketItem', data);
  };

  const handlerChangeTab = () => {
    emit('changeTab', BASKET_TAB_VALUE);
  };

  return {
    handlerSpliceWishItem,
    handlerRestoreWishItem,
    handlerRemoveWishItem,
    handlerClickNotAvailable,
    handlerLoadMore,
    handlerAddToBasketItem,
    handlerChangeTab,
    getCategoryItem,
  };
};

export default useWishList;
